export default "assets/images/icons/marker-ef5a0397.svg";